import type { ReactElement } from 'react';

/** The Healthera green dot: something new to look at on that page. Purple is kept for Plus. */
export default function SidebarDot({ label }: { label: string }): ReactElement {
  return (
    <span className="vtwo:flex vtwo:size-[15px] vtwo:shrink-0 vtwo:items-center vtwo:justify-center">
      <span
        className="vtwo:size-2 vtwo:rounded-full vtwo:bg-[#4db181]"
        role="status"
        aria-label={label}
      />
    </span>
  );
}
